import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { addDays } from 'date-fns';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { CheckVerified01 } from 'untitledui-js-base';
import { parseSqlDateTime } from '../../utils/parseDate';
import { RentalStartType } from '../types/rental';

interface RentStartConfirmDialogProps {
  open: boolean;
  onClose?: () => void;
  onAccept?: (data: RentalStartType) => void;
  isLoading?: boolean;
  rentalDate?: Date;
  returnDate?: Date;
}

export const RentStartConfirmDialog = ({
  onClose,
  onAccept,
  open,
  isLoading,
  rentalDate,
  returnDate
}: RentStartConfirmDialogProps) => {
  const methods = useForm<RentalStartType>({
    shouldUnregister: true,
    defaultValues: {
      rental: {
        rentalDate: parseSqlDateTime(rentalDate) ?? new Date(),
        returnDate: parseSqlDateTime(returnDate) ?? addDays(new Date(), 7)
      }
    }
  });

  const { handleSubmit, control, reset } = methods;

  useEffect(() => {
    reset({
      rental: {
        rentalDate: parseSqlDateTime(rentalDate) ?? new Date(),
        returnDate: parseSqlDateTime(returnDate) ?? addDays(new Date(), 7)
      }
    });
  }, [rentalDate, returnDate]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <form onSubmit={handleSubmit((data) => onAccept?.(data))}>
        <DialogTitle id="alert-dialog-title">Aktivace zápůjčky</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">Opravdu chcete zapůjčit vůz?</DialogContentText>
          <Stack mt={2} gap={2}>
            <Controller
              control={control}
              name="rental.rentalDate"
              render={({ field: { onChange, value } }) => (
                <DateTimePicker label="Datum půjčení" value={value} onChange={onChange} />
              )}
            />
            <Controller
              control={control}
              name="rental.returnDate"
              render={({ field: { onChange, value } }) => (
                <DateTimePicker label="Datum vrácení" value={value} onChange={onChange} />
              )}
            />
          </Stack>
        </DialogContent>
        <DialogActions
          sx={{
            py: 2,
            px: 4,
            justifyContent: 'center',
            flexDirection: { xs: 'column-reverse', md: 'row' },
            gap: 2
          }}
        >
          <Button onClick={onClose}>Zavřít</Button>
          <Button
            variant="contained"
            color="success"
            type="submit"
            loading={isLoading}
            startIcon={<CheckVerified01 />}
            size="large"
          >
            Zapůjčit vůz
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
